import React, { memo } from 'react';

interface IVerifyBadgeProps {
  /** User type; CONTENT_CREATOR renders the blue badge, otherwise a neutral (dark-mode safe) badge. */
  userType?: string | null;
  size?: number;
  className?: string;
}

/**
 * Shared verified/creator badge (seal + check).
 * Single source of truth — do NOT inline this SVG anymore.
 * Colors flip automatically in dark mode via Tailwind `dark:` fill.
 */
const VerifyBadge: React.FC<IVerifyBadgeProps> = ({
  userType,
  size = 16,
  className,
}) => {
  const isCreator = userType === 'CONTENT_CREATOR';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.3333 8L13.7066 6.14667L13.9333 3.69333L11.5266 3.14666L10.2666 1.02666L7.99993 2L5.73326 1.02666L4.47326 3.14666L2.0666 3.68667L2.29326 6.14L0.666595 8L2.29326 9.85333L2.0666 12.3133L4.47326 12.86L5.73326 14.98L7.99993 14L10.2666 14.9733L11.5266 12.8533L13.9333 12.3067L13.7066 9.85333L15.3333 8ZM6.66659 11.3333L3.99993 8.66667L4.93993 7.72667L6.66659 9.44666L11.0599 5.05333L11.9999 6L6.66659 11.3333Z"
        className={
          isCreator
            ? 'fill-[#0057FF]'
            : 'fill-[#080809] dark:fill-slate-300'
        }
      />
    </svg>
  );
};

export default memo(VerifyBadge);
